import api from '../../api/index.js';

export default {
  namespaced: true,
  state     : {
    types             : [],
    type              : '',
    groups            : [],
    group             : '',
    about             : '',
    address           : '',
    country           : '',
    foreign_subsidiary: '',
    countries         : [],
    cities            : [],
    city              : '',
    regions           : [],
    region            : '',
    statuses          : [],
    status            : [],
    email             : '',
    llk               : [],
    llk_current       : '',
    name              : '',
    phone_numbers     : [],
    image             : '',
  },
  getters: {
    company_info     : (state) => state,
    company_group    : ({groups}) => groups,
    active_group     : ({groups}) => groups.find((x) => x.selected),
    get_id           : ({rootGetters}) => rootGetters,
    company_image    : ({image}) => image,
    llk_international: ({llk}) => llk,
    company_type     : ({types}) => types,
    company_id       : ({}, {}, rootState) => rootState.profile.user.user.company_id,
    company_cities   : ({cities}) => cities,
    active_city      : ({cities}) => cities.find((x) => x.selected),
    company_region   : ({regions}) => regions,
    active_region    : ({regions}) => regions.find((x) => x.selected),
    company_statuses : ({statuses}) => statuses,
    active_status    : ({statuses}) => statuses.find((x) => x.active),
    active_type      : ({types}) => types.find((x) => x.selected),
    current_city     : ({cities}) => cities.find((x) => x.selected) ? cities.find((x) => x.selected).id : 0,
    company          : (state, getters) => {
      return {
        image             : state.image,
        group             : state.group,
        about             : state.about,
        address           : state.address,
        region            : state.region,
        country           : state.country,
        foreign_subsidiary: state.foreign_subsidiary,
        status            : state.status,
        type              : state.type,
        city              : state.city,
        email             : state.email,
        name              : state.name,
        phone_numbers     : state.phone_numbers,
        llk               : state.llk_current,
      };
    },
    selected_country: ({countries}) => countries.find((x) => x.selected),
  },
  mutations: {
    SET_SELECTED_GROUP(state, value) {
      const ar = [];
      value.filter((x) => {
        if (x.selected == true) {
          ar.push(x);
        }
      });
      return ar;
    },
    SET_COMPANY_PARAMS(state, value) {
      state.company.regions = value.regions;
    },
    SET_COMPANY_STATUS(state, value) {
      let prev_status = state.statuses.find((item)=>item.active == true);
      let status = state.statuses.find((item)=>item.status == value);
      prev_status.active = false;
      status.active = true;
    },
    SET_COMPANY_DATA(state, value) {
      Object.assign(state, value);

      state.statuses.forEach((x)=>{
        if (x.status == 'status_confirmed') {
          x.bg_color = 'section-label--green';
        }
        if (x.status == 'status_disabled') {
          x.bg_color = 'section-label--red';
        }
        if (x.status == 'status_processing') {
          x.bg_color = 'section-label--blue';
        }
        if (x.status == 'status_rejected') {
          x.bg_color = 'section-label--black';
        }
      });
    },
    SET_COMPANY_REGISTER_DATE(state, value) {
      state.register_date = value;
    },
    CHANGE_USER_STATUS(state, new_status) {
      state.statuses.forEach((x)=> x.active = false);
      const target = state.statuses.find((x) => x.status == new_status.status);
      target.active = !target.active;
    },
    SET_COMPANY_NAME(state, value) {
      state.name = value;
    },
    SET_COMPANY_COUNTRY(state, value) {
      // state.regions.forEach((x)=> x.selected = false);
      // const target = state.regions.find((x) => x.type == value);
      // target.selected = !target.selected;
      state.country = value;
    },
    SET_COMPANY_FOREIGN_SUBSIDIARY(state, value) {
      state.foreign_subsidiary = value;
    },
    SET_COMPANY_REGION(state, value) {
      // state.regions.forEach((x)=> x.selected = false);
      // const target = state.regions.find((x) => x.type == value);
      // target.selected = !target.selected;
      state.region = value;
    },
    SET_COMPANY_CITY(state, value) {
      // state.cities.forEach((x)=> x.selected = false);
      // const target = state.cities.find((x) => x.type == value);
      // target.selected = !target.selected;
      state.city = value;
    },
    SET_COMPANY_GROUP(state, value) {
      // state.groups.forEach((x)=> x.selected = false);
      // const target = state.groups.find((x) => x.type == value);
      // target.selected = !target.selected;
      state.group = value;
    },
    SET_LLL_COMPANY(state, value) {
      // state.llk.forEach((x)=> x.selected = false);
      // const target = state.llk.find((x) => x.type == value);
      // target.selected = !target.selected;
      state.llk_current = value;
    },
    SET_COMPANY_TYPE(state, value) {
      state.type = value;
    },
    SET_COMPANY_ADDRESS(state, value) {
      state.address = value;
    },
    SET_COMPANY_PHONE(state, value) {
      state.phone_numbers = value;
    },
    SET_COMPANY_EMAIL(state, value) {
      const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      state.email = value;
    },
    SET_COMPANY_LOGO(state, value) {
      state.image = value;
    },
    SET_COMPANY_ABOUT(state, value) {
      state.about = value;
    },
  },

  actions: {
    async submit_company({getters, rootGetters, dispatch}, id) {
      const company = getters.company;
      if (!id) {
        id = rootGetters['profile/user/company_id'];
      }

      try {
        await api.company.post_company_by_id(id, company);
        dispatch('replace_company', true);
      } catch (err) {
        console.error(err);
      }
    },

    async replace_company({commit, rootGetters}, id) {
      let comp_id = rootGetters['profile/user/company_id'];
      if (typeof id === 'number') {
        comp_id = id;
      }
      try {
        const res = await api.company.get_company_by_id(comp_id);
        localStorage.setItem('company', JSON.stringify(res.data));
        commit('SET_COMPANY_DATA', res.data);
      } catch (err) {
        console.error(err);
      }
    },

  },
};
